import React from 'react';
import { CheckIcon, DownloadIcon, PrinterIcon, ShoppingCartIcon, SchoolIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const steps = [{
  icon: ShoppingCartIcon,
  title: 'Comprás',
  text: 'Hacés tu compra una sola vez.'
}, {
  icon: DownloadIcon,
  title: 'Descargás',
  text: 'Accedés sin esperar.'
}, {
  icon: CheckIcon,
  title: 'Elegís',
  text: 'Buscás la propuesta que necesitás.'
}, {
  icon: PrinterIcon,
  title: 'Imprimís',
  text: 'Dejás todo listo en minutos.'
}, {
  icon: SchoolIcon,
  title: 'Entrás al aula',
  text: 'Preparada, tranquila y segura.'
}];
export function HowItWorksSection() {
  return <section className="bg-orange-50 py-10 sm:py-14 md:py-16" data-id="element-69">
      <div className="container mx-auto px-4 md:px-6" data-id="element-70">
        <div className="mx-auto max-w-3xl text-center" data-id="element-71">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-orange-600" data-id="element-72">
            Sin vueltas, sin domingos eternos
          </p>
          <h2 className="mt-2 text-3xl font-black leading-tight tracking-tight text-slate-900 sm:text-4xl" data-id="element-73">
            Así de simple funciona.
          </h2>
        </div>
        <ol className="mx-auto mt-6 grid max-w-6xl grid-cols-2 gap-2.5 sm:grid-cols-3 sm:gap-3 lg:grid-cols-5" data-id="element-74">
          {steps.map(({
          icon: Icon,
          title,
          text
        }, index) => <motion.li key={title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="relative rounded-2xl border border-orange-100 bg-white p-3 shadow-sm sm:p-4" data-id="element-75">
              <span className="absolute right-2.5 top-2.5 text-[11px] font-black text-orange-200" data-id="element-76">
                0{index + 1}
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-yellow-100 text-orange-600" data-id="element-77">
                <Icon className="h-4.5 w-4.5" data-id="element-78" />
              </span>
              <h3 className="mt-3 text-sm font-black text-slate-900 sm:text-base" data-id="element-79">
                {title}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-slate-600" data-id="element-80">
                {text}
              </p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}